// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__OxL1O","loading":"loading_loading__Jke2z","spinner":"loading_spinner__Vqiqw","content":"loading_content__3UGFc"};